import { createContext, Dispatch, SetStateAction } from "react";

import { FormInstance } from "antd";

import { AdditionalDataClient, BankAccount, CoveragePerPlan, CreditCardsInsured, GetLocalitiesListPerProvinceResponse, Locality, PaymentMethodForms, QuotationClient, RequestCoveragesByPlanActivities, SelectOption } from "../../../../../../../shared/interfaces";
import { AdditionalDataSectionForm, ClientDataSectionForm, PaymentMethodSectionForm, ProvincesInderCodes } from "./GenericDataFormProvider";


interface GenericDataFormContextProps {
    /** All Localities */
    allLocalities:                      GetLocalitiesListPerProvinceResponse | undefined;

    /** Flag if error in services */
    isErrorServices: boolean;
    setIsErrorServices: Dispatch<SetStateAction<boolean>>;

    /** Generic state of is loading */
    canShowSpinner:                     boolean;
    setCanShowSpinner:                  Dispatch<SetStateAction<boolean>>;

    /** List of Different Payment methods */
    paymentMethodsList:                 Array<PaymentMethodForms>;
    setPaymentMethodsList:              Dispatch<SetStateAction<Array<PaymentMethodForms>>>

    /** List of Different Payment methods for use in Select */
    paymentMethods:                     Array<SelectOption>;
    setPaymentMethods:                  Dispatch<SetStateAction<Array<SelectOption>>>

    /** List of Different Type Person for use in Select */
    typePersonList?:                    Array<SelectOption>;

    /** List of Different Document Types for use in Select */
    documentTypeList?:                  Array<SelectOption>;

    /** List of Provinces of Argentina for use in Select */
    provinceList?:                      Array<SelectOption>;

    /** List of inder codes of Provinces of Argentina for use in Select */
    provinceListInder?:                      Array<ProvincesInderCodes>;
    
    /** List of localities per province of Argentina for use in Select */
    localities?:                        Array<SelectOption>;
    setLocalities:                      Dispatch<SetStateAction<Array<SelectOption> | undefined>>;

    /** List of Conditions of IVA for use in Select */
    ivaConditionList?:                  Array<SelectOption>;

    /** List of Society Type for use in Select */
    typeSocietyList:                    Array<SelectOption>;

    /** List of economy activity branches for use in Select */
    branchEconomyActivityList:          Array<SelectOption>; 

    /** List of Civil status for use in Select */
    civilStatusList:                    Array<SelectOption>;

    /** List of Countries for use in Select */
    countryList:                        Array<SelectOption>;    

    /** List of Professions for use in Select */
    professionList:                     Array<SelectOption>;    

    /** Flag for determine if the list of localities is loading  */
    isLoadingLocalities:                boolean;

    /** Flag for determine if the list of document types is loading  */
    isLoadingDocumentTypeList:          boolean;

    /** Flag for determine if the list of iva conditions is loading  */
    isLoadingIvaConditionList:          boolean;

    /** Flag for determine if the list of provinces is loading  */
    isLoadingProvinceList:              boolean;

    /** Flag for determine if the list of person types is loading  */
    isLoadingTypePersonList:            boolean;

    /** Flag for determine if the list of society types is loading  */
    isLoadingTypeSocietyList:           boolean;

    /** List of genders for use in Select */
    genderList:                         Array<SelectOption>;

    /** Flag to indicate if the gender list is loading */
    isLoadingGenderList:                boolean;

    /** List of nationalities for use in Select */
    nationalityList:                    Array<SelectOption>;

    /** Flag to indicate if the nationalities list is loading */
    isLoadingNationalityList:           boolean;

    /** List of credit cards for use in Select */
    listCreditCardInsured:              CreditCardsInsured | undefined;
    setListCreditCardInsured:           Dispatch<SetStateAction<CreditCardsInsured | undefined>>;

    /** Form instance for client data section */
    clientDataSectionForm:              FormInstance<ClientDataSectionForm>;

    /** Variable to save client data form  values */
    clientDataFormValues:               ClientDataSectionForm | undefined;
    setclientDataFormValues:            Dispatch<SetStateAction<ClientDataSectionForm | undefined>>;

    /** Form instance for additional data section */
    additionalDataSectionForm:          FormInstance<AdditionalDataSectionForm>;

    /** Variable to save additional data form values */
    additionalDataFormValues:           AdditionalDataSectionForm | undefined;     
    setAdditionalDataFormValues:        Dispatch<SetStateAction<AdditionalDataSectionForm | undefined>>;

    /** Form instance for payment method section of issue */
    paymentMethodSectionForm:           FormInstance<PaymentMethodSectionForm>;

    /** Variable to save payment method form values */
    paymentMethodFormValues:            PaymentMethodSectionForm | undefined;
    setPaymentMethodFormValues:         Dispatch<SetStateAction<PaymentMethodSectionForm | undefined>>;

    listBankAccountByInsured:           BankAccount | undefined;
    setListBankAccountByInsured:        Dispatch<SetStateAction<BankAccount | undefined>>;

    listCreditCards:                    Array<SelectOption> | undefined;
    setListCreditCards:                 Dispatch<SetStateAction<Array<SelectOption> | undefined>>;

    isLoadingListCreditCards:           boolean;

    /** Flag to indicate if the payment methods list is loading */
    isLoadingPaymentMethods:            boolean;
    setIsLoadingPaymentMethods:         Dispatch<SetStateAction<boolean>>;

    /** Variable for save all info about localities per province */
    allLocalitiesPerProvince:           Array<{ provinceCode: string, localities: Array<Locality>, localitiesOptions: Array<SelectOption> }>;

    /** Variable for save all coverages per plan */
    allCoveragesPerPlan:                Array<{ plan: string | RequestCoveragesByPlanActivities, coverages: Array<CoveragePerPlan> }>;

    allCoveragesPerPlanRisk:            Array<{ plan: string | RequestCoveragesByPlanActivities, coverages: Array<CoveragePerPlan> }>;

    /** Set plans selected in each product quotation */
    plansSelected:                      string[] | RequestCoveragesByPlanActivities[];
    setPlansSelected:                   Dispatch<SetStateAction<string[] | RequestCoveragesByPlanActivities[]>>;

    tabsUserCanNotDelete:               Array<number>;
    setTabsUserCanNotDelete:            Dispatch<SetStateAction<Array<number>>>;

    formValues:                         { [key: string]: any };
    setFormValues:                      Dispatch<SetStateAction<{ [key: string]: any }>>;

    removedTabIndexes:                  Array<number>;
    setRemovedTabIndexes:               Dispatch<SetStateAction<Array<number>>>;

    userCanDeleteTabs:                  boolean;
    setUserCanDeleteTabs:               Dispatch<SetStateAction<boolean>>;

    //* Methods

    /** Method for get localities of a province */
    getLocalitiesPerProvince:           ( provinceCode: string ) => Promise<void>;

    /** Method for get list of bank accounts per insured */
    getListBankAccountByInsured:        ( nroAsegurado: string ) => Promise<void>;

    /** Method for get list of credit cards per insured  */
    getListCreditCardByInsured:         ( nroAsegurado: string ) => Promise<void>;

    /** Method for get list of credit card companies  */
    getListCreditCards:                 () => Promise<void>;

    /** Method for save quotation */
    saveQuotation:                      ( client: QuotationClient, additionalDataClientSelected: AdditionalDataClient ) => Promise<void>;

    getGenericDataForm:                 () => Promise<void>;

    /** Method for get localities from state */
    getLocalitiesByProvinceFromState:   ( provinceCode: string ) => Array<SelectOption> | undefined;

    /** Method for get relation with other coverage */
    getRelationWithOtherCoverage:       ( coverageCode: string, allCoverages: Array<CoveragePerPlan> ) => { codigoCoberturaRelacionada: string,  codigoRiesgo: string } | undefined;

    /** Method for set plans selected by each tab */
    setPlansSelectedByTabs:             ( tabs: Array<any>, form?: FormInstance<any> ) => void;

    /** Method for get locality info */
    getLocalityInfo:                    (provinceCode: string, postalCodeSufix: string, postalCode: string) => Locality | undefined;

    getCoveragesPerPlan:                () => Promise<void>;
    getCoveragesPerPlanRisk:            (riskCode: string, activityCode: string) => Promise<void>;

    updateFormsAfterRemoveTabs:         (tabsIndexes: Array<number>, forms: Array<FormInstance<any>>, oldFieldsValue?: { [key: string]: any }) => void;
}  

export const GenericDataFormContext = createContext({} as GenericDataFormContextProps);